import { Nullable } from 'common-types';
import { createStore } from 'store-utils';
import { ActiveMember } from '../types/members-types';

const UpdateUserRolesStore = createStore<UpdateUserRolesStoreState>(
  {
    selectedMember: null,
    isModalVisible: false,
  },
  'Update User Roles Store',
);

interface UpdateUserRolesStoreState {
  selectedMember: Nullable<ActiveMember>;
  isModalVisible: boolean;
}

export default UpdateUserRolesStore;
